<template>
	<div class="page-content">
		<div class="tabs">
			<div :class="{'active': orderTab == 1}" @click="switchTab(1)">待付款</div>
			<div :class="{'active': orderTab == 2}" @click="switchTab(2)">进行中</div>
			<div :class="{'active': orderTab == 3}" @click="switchTab(3)">已完成</div>
			<div :class="{'active': orderTab == 4}" @click="switchTab(4)">过期/退款</div>
		</div>
		<div class="order-lists">
			<nut-infiniteloading :has-more="isHasMore" :is-show-mod="true" :is-loading="isLoading" :unload-more-txt="isHasMore ? '加载中' : '没有更多了'" :threshold="200" @loadmore="onInfinite">
				<template v-if="listData && listData.length">
					<div class="list-item" v-for="(item,index) in listData" :key="index">
						<div class="order-list" v-if="item.data">
							<div v-if="item.order_prom_type == 1221 && item.teamInfo">
								<!-- 拼团订单 -->
								<div class="group-list" @click="routerToDetail(orderTab,item)">
									<div class="st">
										<div class="top">
											<img src="../../assets/images/icon_car.png" alt="">
											<span class="name" v-if="item.data">{{item.data[0].store_name}}</span>
											<span v-if="orderTab == 1">待付款</span>
											<div v-if="item.teamInfo.less > 0">
												<span class="color111" v-if="orderTab == 2">待分享，差{{item.teamInfo.less_t}}人</span>
											</div>
											<div v-else>
												<span class="color666" v-if="orderTab == 2">拼团成功,待核销</span>
											</div>
											<span class="color999" v-if="orderTab == 3">已完成</span>
											<div v-if="orderTab == 4">
												<span class="color999" v-if="item.pay_status == 3">已退款</span>
												<span class="color999" v-else-if="item.refund_status == 1">退款申请中</span>
												<span class="color999" v-else-if="item.refund_status == 3">退款已拒绝</span>
												<span class="color999" v-else-if="item.order_status == 3">已取消</span>
												<span class="color999" v-else>已过期</span>
											</div>
										</div>
										<div class="order-number">订单编号：{{item.order_sn}}</div>
									</div>
									<div class="class-type">
										<div v-for="(vo,ks) in item.data" :key="ks">
											<div class="top">
												<span>{{vo.goods_name}}</span>
												<div class="group">拼团</div>
											</div>
											<div class="mid">
												<div class="tag">{{vo.cat_id2_text}}</div>
												<!--<div class="tag">{{vo.cat_id3_text}}</div>-->
												<div class="tag">{{vo.cat_id4_text}}</div>
											</div>
										</div>
										<div class="bot">
											<span class="old-price"><em class="money">￥{{item.teamInfo.goods_price}}</em>元</span>
											<span class="group-price">{{item.teamInfo.need}}人团：￥{{item.teamInfo.price}}元</span>
										</div>
										<div class="opration">
											<div class="heads" v-if="orderTab != 3">
												<div v-for="(heads,heads_key) in item.teamHead" :key="heads_key">
													<img :src="heads" alt="">
												</div>
											</div>
											<template v-if="orderTab == 1">
												<span @click.stop="cancelOrder(item.order_id)">取消订单</span>
												<div class="btn" @click.stop="goPay(item.order_id)">去付款</div>
											</template>
											<template v-if="orderTab == 2">
												<span v-if="can_refund && parseFloat(item.total_amount) > 0" @click.stop="refund(item.order_id)">申请退款</span>
												<!--邀请好友拼单,也是跳转到订单详情页-->
												<div v-if="item.teamInfo.less > 0"><div class="btn invite">邀请好友拼单</div></div>
												<div v-else><div class="btn look-order">查看订单</div></div>
											</template>
											<template v-if="orderTab == 3">
												<span class="real-pay">实付：<em>￥{{item.total_amount}}元</em></span>
												<div class="btn look-order">查看详情</div>
											</template>
											<template v-if="orderTab == 4">
												<div v-if="parseInt(item.refund_status) !== 1" class="btn look-order" @click.stop="anewPay(item,item.data[0],item.teamInfo)">重新下单</div>
											</template>
										</div>
									</div>
								</div>
							</div>
							<div v-else-if="item.order_prom_type == 1219">
								<!-- 报名学车订单订单 -->
								<div class="group-list single-list" @click="routerToDetail(orderTab,item)">
									<div class="st">
										<div class="top">
											<img src="../../assets/images/icon_car.png" alt="">
											<span class="name" v-if="item.data">{{item.data[0].store_name}}</span>
											<span v-if="orderTab == 1">待付款</span>
											<span class="color666" v-if="orderTab == 2">购买成功，待核销</span>
											<span class="color999" v-if="orderTab == 3">已完成</span>
											<div v-if="orderTab == 4">
												<span class="color999" v-if="item.pay_status == 3">已退款</span>
												<span class="color999" v-else-if="item.refund_status == 1">退款申请中</span>
												<span class="color999" v-else-if="item.refund_status == 3">退款已拒绝</span>
												<span class="color999" v-else-if="item.order_status == 3">已取消</span>
												<span class="color999" v-else>已过期</span>
											</div>
										</div>
										<div class="order-number">订单编号：{{item.order_sn}}</div>
									</div>
									<div v-for="(vo,ks) in item.data" :key="ks">
										<div class="class-type">
											<div class="top">
												<span>{{vo.goods_name}}</span>
												<span class="price">￥{{item.total_amount}}元</span>
											</div>
											<div class="mid">
												<div class="tag">{{vo.cat_id2_text}}</div>
												<!--<div class="tag">{{vo.cat_id3_text}}</div>-->
												<div class="tag">{{vo.cat_id4_text}}</div>
											</div>
											<div class="opration">
												<template v-if="orderTab == 1">
													<span @click.stop="cancelOrder(item.order_id)">取消订单</span>
													<div class="btn" @click.stop="goPay(item.order_id)">去付款</div>
												</template>
												<template v-if="orderTab == 2">
													<span v-if="can_refund && parseFloat(item.total_amount) > 0" @click.stop="refund(item.order_id)">申请退款</span>
													<div class="btn look-order">查看订单</div>
												</template>
												<template v-if="orderTab == 3">
													<span class="real-pay">实付：<em>￥{{item.total_amount}}元</em></span>
													<div class="btn look-order">查看详情</div>
												</template>
												<template v-if="orderTab == 4">
													<div v-if="parseInt(item.refund_status) !== 1" class="btn look-order" @click.stop="anewPay(item,vo)">重新下单</div>
												</template>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-else-if="item.order_prom_type == 1223">
								<!-- 优惠券订单 -->
								<div class="group-list coupon-list" @click="routerToDetail(orderTab,item)">
									<div class="st">
										<div class="top">
											<img src="../../assets/images/icon_bd.png" alt="">
											<span class="name" v-if="item.data[0].spec_id == 1">驾校优惠卷</span>
											<span class="name" v-else>平台优惠卷</span>
											<span v-if="orderTab == 1">待付款</span>
											<span class="color666" v-if="orderTab == 2">购买成功，待核销</span>
											<span class="color999" v-if="orderTab == 3">已完成</span>
											<div v-if="orderTab == 4">
												<span class="color999" v-if="item.pay_status == 3">已退款</span>
												<span class="color999" v-else-if="item.refund_status == 1">退款申请中</span>
												<span class="color999" v-else-if="item.refund_status == 3">退款已拒绝</span>
												<span class="color999" v-else-if="item.order_status == 3">已取消</span>
												<span class="color999" v-else>已过期</span>
											</div>
										</div>
										<div class="order-number">订单编号：{{item.order_sn}}</div>
									</div>
									<div class="class-type">
										<div v-for="(vo,ks) in item.data" :key="ks">
											<div class="top">
												<span>{{vo.goods_name}}</span>
												<div class="vouchers">券</div>
												<span class="price">￥{{item.total_amount}}元</span>
											</div>
											<div class="mid">
												<div class="tag" v-if="vo.short_name !== ''">{{vo.short_name}}</div>
												<div class="tag" v-else>学车立减</div>
											</div>
										</div>
										<div class="opration">
											<template v-if="orderTab == 1">
												<span @click.stop="cancelOrder(item.order_id)">取消订单</span>
												<div class="btn" @click.stop="goPay(item.order_id)">去付款</div>
											</template>
											<template v-if="orderTab == 2">
												<span v-if="can_refund && parseFloat(item.total_amount) > 0" @click.stop="refund(item.order_id)">申请退款</span>
												<div class="btn look-order">查看订单</div>
											</template>
											<template v-if="orderTab == 3">
												<span class="real-pay">实付：<em>￥{{item.total_amount}}元</em></span>
												<div class="btn look-order">查看详情</div>
											</template>
											<template v-if="orderTab == 4">
												<div v-if="parseInt(item.refund_status) !== 1" class="btn look-order" @click.stop="anewPay(item,item.data[0])">重新下单</div>
											</template>
										</div>
									</div>
								</div>
							</div>
							<div v-else-if="item.order_prom_type == 1225">
								<!-- 礼物订单 -->
								<div class="group-list gift-list" @click="routerToDetail(orderTab,item)">
									<div class="st">
										<div class="top">
											<img src="../../assets/images/icon_car.png" alt="">
											<span class="order-n">订单编号：{{item.order_sn}}</span>
											<span v-if="orderTab == 1">待付款</span>
											<span class="color999" v-else-if="orderTab == 4">已过期</span>
											<span class="color999" v-else>已完成</span>
										</div>
									</div>
									<div class="class-type">
										<div v-for="(vo,ks) in item.data" :key="ks">
											<div class="gift-info">
												<div class="img-box">
													<img :src="vo.original_img" alt="">
												</div>
												<span class="gift-name">{{vo.goods_name}}(打赏{{vo.to_user_name}})</span>
												<div class="pan">
													<span>￥{{item.total_amount}}</span>
													<span class="gift-n">x{{item.data[0].goods_num}}</span>
												</div>
											</div>
										</div>
										<div class="opration">
											<template v-if="orderTab == 1">
												<span @click.stop="cancelOrder(item.order_id)">取消订单</span>
												<div class="btn" @click.stop="goPay(item.order_id)">去付款</div>
											</template>
											<template v-if="orderTab == 3">
												<span class="real-pay">实付：<em>￥{{item.total_amount}}元</em></span>
												<div class="btn look-order">查看详情</div>
											</template>
											<template v-if="orderTab == 4">
												<div v-if="parseInt(item.refund_status) !== 1" class="btn look-order" @click.stop="anewPay(item,item.data[0])">重新下单</div>
											</template>
										</div>
									</div>
								</div>
							</div>
							<div v-else-if="item.order_prom_type == 1250 || item.order_prom_type == 1251">
								<!-- 加油订单 -->
								<div class="group-list coupon-list" @click="routerToDetail(orderTab,item)">
									<div class="st">
										<div class="top">
											<img src="../../assets/images/icon_oil.png" alt="" style="width: 12px;">
											<span class="name">{{item.business_name}}</span>
											<span v-if="orderTab == 1">待付款</span>
											<span class="color666" v-if="orderTab == 2">已支付</span>
											<span class="color999" v-if="orderTab == 3">已完成</span>
											<div v-if="orderTab == 4">
												<span class="color999" v-if="item.pay_status == 3">已退款</span>
												<span class="color999" v-else-if="item.refund_status == 1">退款申请中</span>
												<span class="color999" v-else-if="item.refund_status == 3">退款已拒绝</span>
												<span class="color999" v-else-if="item.order_status == 3">已取消</span>
												<span class="color999" v-else>已过期</span>
											</div>
										</div>
										<div class="order-number">订单编号：{{item.order_sn}}</div>
									</div>
									<div class="class-type">
										<div v-for="(vo,ks) in item.data" :key="ks">
											<div class="top">
												<span>{{vo.goods_name}}</span>
												<span class="price">￥{{(Number(item.data[0].goods_price)+Number(item.platform_fee)).toFixed(2)}}元</span>
											</div>
											<div class="mid">
												<div class="tag" v-if="vo.short_name !== ''">{{vo.short_name}}</div>
											</div>
										</div>
										<div class="opration">
											<template v-if="orderTab == 1">
												<span @click.stop="cancelOrder(item.order_id)">取消订单</span>
												<div class="btn" @click.stop="oilGoPay(item.order_id)">去付款</div>
											</template>
											<!-- <template v-if="orderTab == 2">
												<span v-if="can_refund && parseFloat(item.total_amount) > 0" @click.stop="refund(item.order_id)">申请退款</span>
												<div class="btn look-order">查看订单</div>
											</template> -->
											<template v-if="orderTab == 3">
												<span class="real-pay">实付：<em>￥{{(Number(item.data[0].goods_price)+Number(item.platform_fee)).toFixed(2)}}元</em></span>
												<div class="btn look-order">查看详情</div>
											</template>
											<!-- <template v-if="orderTab == 4">
												<div v-if="parseInt(item.refund_status) !== 1" class="btn look-order" @click.stop="anewPay(item,item.data[0])">重新下单</div>
											</template> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
				<empty v-else></empty>
				<!-- 根据ui自定义没有更多了样式 -->
				<!-- <div class="no-more-data">
					<div class="line-left"></div>
					<span>没有更多了</span>
					<div class="line-right"></div>
				</div> -->
			</nut-infiniteloading>
		</div>
	</div>
</template>

<script>
import empty from '../Empty'

export default {
	name: 'MyOrder',
	metaInfo: {
		title: '我的订单',
		titleTemplate: null,
	},
	components: {empty},
	data:()=> ({
		orderTab: 1, //tab选项卡选中项
		isHasMore: false, //是否有更多数据可以分页滚动
		isLoading: false, //是否展示加载中动画
		page: 1,
		pageSize: 15,//首次15条,以后每次10条
		listData:[],
		can_refund:2,	//是否可申请退款
	}),

	created() {
		//类型值获取
		const type_params = this.$route.query.type;
		const type = type_params ? type_params : 1;
		this.orderTab = type;
		this.getList();
	},
	methods: {
		getList(){
			this.isHasMore = false;
			this.$ajax.get('m/trade/order_list', {
				id: this.$ajax.get_activity_id(),
				type:this.orderTab,
				pageIndex: this.page,
				pageSize: this.pageSize
			}).then(res => {
				this.isLoading = false;
				this.can_refund = res.can_refund;
				if (res && res.order_list.length) {
					this.listData = res.order_list;
					//this.listData.push(res.order_list);
					if(res.order_list.length >= this.pageSize){
						this.isHasMore = true;
					}else {
						this.isHasMore = false;
					}
					this.pageSize = 10;
					this.page++;
				} else {
					this.isHasMore = false;
				}
			})
		},
		/*
		 * 切换tab选项卡
		 * @param {Number} index - 下标
		 */
		switchTab(index) {
			this.listData = [];
			this.orderTab = index;
			this.isLoading = true
			this.pageSize = 15;
			this.page = 1;
			this.getList();
		},
		// 分页请求
		onInfinite() {
			this.getList();
		},
		/*
		 * 查看订单详情
		 * @param {Number} status - 订单状态 1待付款 2进行中 3已完成 4过期 5退款
		 * @param {arr} order - 订单数据
		 * //@param {Number} progress - 订单进行中状态下处于哪个阶段 1拼团成功待分享 2拼团成功待核销 3购买成功待核销
		 */
		routerToDetail(status, order) {
			if(order.order_prom_type == '1250' || order.order_prom_type == '1251'){
				var host = window.location.host;
				window.location.href = 'http://'+host+'/maintain/#/pages/order-detail/order-detail?id='+order.order_id;
			}else{
				if (status == 1) {			//待支付
					this.$router.push({ name: 'ODToBePaid', query: { id: order.order_id}})
				} else if (status == 2) {	//进行中
					this.$router.push({ name: 'ODOngoing', query: { id: order.order_id}})
				} else if (status == 3) {	//已完成
					this.$router.push({ name: 'ODCompleted', query: { id: order.order_id}})
				} else{						//过期|退款
					if(order.pay_status == 3 || order.refund_status ==1 || order.refund_status == 3){
						//退款
						this.$router.push({ name: 'ODRefund', query: { id: order.order_id}})
					}else {
						//过期
						this.$router.push({ name: 'ODCompleted', query: { id: order.order_id}})
					}
				}
			}
			
		},
		/**
		 * 订单取消[用户手动]
		 * @param order_id
		 */
		cancelOrder(order_id){
			this.isLoading = true;
			this.$ajax.get('m/trade/cancel_order', {
				order_id: order_id
			}).then(res => {
				this.$toast.text(res)
				setTimeout(()=>{
					this.$router.push({name:'MyOrder'})
				},2000)
				this.listData = [];
				this.isLoading = true
				this.pageSize = 15;
				this.page = 1;
				this.getList();
			})
		},
		/**
		 * 跳转支付页
		 * @param order_id
		 */
		goPay(order_id){
			this.$router.push({name:'SureOrder',query:{order_id:order_id}});
		},
		/**
		 * 申请退款
		 * @param order_id
		 */
		refund(order_id){
			this.$router.push({name:'ApplyRefund',query:{order_id:order_id}});
		},
		/**
		 * 重新下单
		 * @param order
		 * @param order_goods
		 * @param timeInfo
		 */
		anewPay(order,order_goods,timeInfo = null){
			var params = {};
			params.activity_id = this.$ajax.get_activity_id();
			params.num = 1;
			params.order_prom_type=parseInt(order.order_prom_type);

			switch (parseInt(order.order_prom_type)) {
				case 1219:	//报名学车
					params.goods_id = order_goods.goods_id;
					break;
				case 1221:	//拼团学车
					params.team_id= timeInfo.team_id;
					params.team_price_type=1;
					params.team_fllow_type="open";
					break;
				case 1223:  //优惠卷
					params.coupon_id=order_goods.goods_id;
					break;
				case 1225:	//礼物
					params.gift_id=order_goods.gift_id;
					params.sale_adviser_id=order_goods.sale_adviser_id;
					break;
				default:
					this.$toast.text('该订单已失效~')
					setTimeout(()=>{
						this.$router.push({name:'User'})
					},2000)
			}
			//下单|会自动跳转
			this.$ajax.get('m/order/add_order', params).then(order_id => {
				this.$router.push({name: 'SureOrder', query: {order_id: order_id}});
			})
		}
	},
	mounted() {

	}
}
</script>

<style lang="less" scoped>
	.page-content {
		width: 100%;
		.tabs {
			width: 100%;
			height: 40px;
			display: flex;
			position: fixed;
			top: 0;
			left: 0;
			background-color: #fff;
			div {
				width: 25%;
				height: 100%;
				line-height: 40px;
				text-align: center;
				font-size: 16px;
				color: #666;
			}
			.active {
				font-weight: bold;
				color: #333;
				border-bottom: 2px #3C43EC solid;
			}
		}
		.order-lists {
			width: 100%;
			box-sizing: border-box;
			padding: 0 15px;
			margin-top: 55px;
			.order-list {
				width: 100%;
				box-shadow: 0px 0px 12px rgba(0,0,0,0.08);
				border-radius: 3px;
				margin-top: 15px;
				.group-list {
					width: 100%;
					display: flex;
					flex-direction: column;
					.st {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						.top {
							display: flex;
							align-items: center;
							justify-content: space-between;
							span {
								font-size: 15px;
								color: #EB273B;
							}
							.name {
								margin-left: 5px;
								flex: 1;
								color: #333;
							}
							.order-n {
								margin-left: 5px;
								flex: 1;
								color: #999;
							}
							.color333 {
								color: #333;
							}
							.color666 {
								color: #666;
							}
							.color999 {
								color: #999;
							}
							.color111 {
								color: #ff9bbd;
								font-weight: bold;
							}
						}
						.order-number {
							font-size: 14px;
							color: #999;
							box-sizing: border-box;
							padding-left: 19px;
							margin-top: 5px;
						}
					}
					.class-type {
						width: 100%;
						box-sizing: border-box;
						padding: 10px 10px 0;
						border-top: 1px #E2E2E2 solid;
						.top {
							width: 100%;
							display: flex;
							align-items: center;
							span {
								font-size: 15px;
								color: #333;
							}
							.group {
								width: 32px;
								height: 20px;
								background-color: #FF808E;
								border-radius: 3px;
								line-height: 20px;
								text-align: center;
								font-size: 12px;
								color: #fff;
								margin-left: 5px;
							}
							.vouchers {
								width: 32px;
								height: 20px;
								background-color: #6FCBF3;
								border-radius: 3px;
								line-height: 20px;
								text-align: center;
								font-size: 12px;
								color: #fff;
								margin-left: 5px;
							}
							.price {
								font-size: 14px;
								color: #EB273B;
								flex: 1;
								text-align: right;
							}
						}
						.mid {
							width: 100%;
							display: flex;
							flex-wrap: wrap;
							margin-top: 10px;
							.tag {
								height: 20px;
								line-height: 20px;
								background-color: #F8F8F8;
								border-radius: 3px;
								font-size: 12px;
								color: #666;
								margin-right: 5px;
								box-sizing: border-box;
								padding: 0 5px;
							}
						}
						.bot {
							width: 100%;
							margin-top: 10px;
							display: flex;
							align-items: center;
							.old-price {
								font-size: 14px;
								color: #999;
								margin-right: 10px;
								.money {
									font-style: normal;
									text-decoration: line-through;
									margin-right: 3px;
								}
							}
							.group-price {
								font-size: 14px;
								color: #EB273B;
							}
						}
						.gift-info {
							width: 100%;
							display: flex;
							justify-content: space-between;
							.img-box {
								width: 60px;
								height: 60px;
								box-sizing: border-box;
								padding: 8px 5px;
								border-radius: 3px;
								border: 1px #E2E2E2 solid;
								img {
									width: 100%;
									height: 100%;
									object-fit: cover;
								}
							}
							span {
								font-size: 15px;
								color: #EB273B;
								em {
									font-style: normal;
									font-size: 12px;
								}
							}
							.gift-name {
								flex: 1;
								margin-left: 10px;
								color: #333;
							}
							.pan {
								display: flex;
								flex-direction: column;
								align-items: flex-end;
								.gift-n {
									font-size: 12px;
									color: #999;
									margin-top: 5px;
								}
							}
						}
					}
					.opration {
						width: 100%;
						box-sizing: border-box;
						padding: 10px 0;
						border-top: 1px #E2E2E2 solid;
						display: flex;
						align-items: center;
						justify-content: flex-end;
						margin-top: 10px;
						.heads {
							display: flex;
							flex: 1;
							width: 100%;
							overflow: auto;
							img {
								width: 30px;
								height: 30px;
								border-radius: 50%;
								object-fit: cover;
								margin-left: -8px;
							}
							img:first-child {
								margin-left: 0;
							}
						}
						span {
							flex: 1;
							text-align: right;
							font-size: 12px;
							color: #666;
							margin-right: 10px;
						}
						.real-pay {
							font-size: 14px;
							color: #666;
							em {
								font-style: normal;
								color: #EB273B;
							}
						}
						.btn {
							box-sizing: border-box;
							padding: 0 20px;
							height: 30px;
							background: linear-gradient(204deg,rgba(255,171,90,1) 0%,rgba(252,106,69,1) 100%);
							border-radius: 30px;
							line-height: 30px;
							text-align: center;
							font-size: 12px;
							color: #fff;
						}
						.btn.invite {
							background: linear-gradient(45deg,rgba(255,103,155,1) 0%,rgba(255,155,189,1) 100%);
						}
						.btn.look-order {
							background: #fff;
							border: 1px solid rgba(102,102,102,1);
							color: #666;
						}
					}
				}
			}
			.no-more-data {
				width: 100%;
				margin: 20px 0 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				.line-left {
					width: 30px;
					height: 1px;
					background: linear-gradient(90deg,rgba(153,153,153,0) 0%,rgba(153,153,153,1) 100%);
				}
				span {
					font-size: 12px;
					color: #999;
					margin: 0 10px;
				}
				.line-right {
					width: 30px;
					height: 1px;
					background: linear-gradient(270deg,rgba(153,153,153,0) 0%,rgba(153,153,153,1) 100%);
				}
			}
		}
	}
</style>
